import { BASE_URL, GET, PATCH, SERVICE_LIST } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";


export const fetchServiceDetail = async (requestId) => {

  const token = await getAccessToken();
  const url = `${BASE_URL}${SERVICE_LIST}/${requestId}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};

  export const addAdditionalEmail = async (payload ,id) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${SERVICE_LIST}/${id}/${"additional-emails"}`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };